import AlternativeProjects from './AlternativeProjects';

export default AlternativeProjects;



// WEBPACK FOOTER //
// ./src/components/AlternativeProjects/index.tsx